import { Check, PlayCircle, MonitorSmartphone, Download, Award } from 'lucide-react';

const STATIC_INCLUDES = [
  { icon: MonitorSmartphone, label: 'Access on mobile and laptop' },
  { icon: Download, label: 'Downloadable resources' },
  { icon: Award, label: 'Certificate of completion' },
];

const BeginnerCourseContent = ({ content, instructor, singleLevel = false, facultyImage, videoDuration }) => {
  if (!content) return null;

  const courseIncludes = [
    { icon: PlayCircle, label: `${videoDuration} on-demand video` },
    ...STATIC_INCLUDES,
  ];

  return (
    <div className="space-y-16">
      <div>
        {!singleLevel && (
          <>
            <p className="chapter-label mb-4">BEGINNER</p>
            <h2 className="display-heading text-3xl md:text-4xl text-white mb-6">{content.title}</h2>
            {content.overview && (
              <p className="text-base leading-relaxed text-zinc-300 mb-10 max-w-3xl whitespace-pre-line">
                {content.overview}
              </p>
            )}
          </>
        )}

        <p className="text-sm font-semibold tracking-[0.15em] uppercase text-zinc-400 mb-6">
          This course includes:
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {courseIncludes.map(({ icon: Icon, label }) => (
            <div
              key={label}
              className="flex items-center gap-4 p-5 border border-white/5 bg-[#0D0D0D]"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#C8102E]/15 border border-[#C8102E]/30">
                <Icon className="w-5 h-5 text-[#C8102E]" strokeWidth={1.75} />
              </div>
              <span className="text-sm text-zinc-200 leading-snug">{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div>
        <p className="chapter-label mb-4">SKILLS YOU&apos;LL GAIN</p>
        <div className="flex flex-wrap gap-3">
          {content.skills.map((skill) => (
            <span
              key={skill}
              className="px-4 py-2 text-xs tracking-[0.15em] uppercase border border-[#C8102E]/30 bg-[#C8102E]/10 text-zinc-200"
            >
              {skill}
            </span>
          ))}
        </div>
      </div>

      <div>
        <p className="chapter-label mb-4">WHAT YOU&apos;LL LEARN</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {content.whatYouLearn.map((item, idx) => (
            <div key={idx} className="flex gap-4 p-5 border border-white/5 bg-[#0D0D0D]">
              <Check className="w-5 h-5 text-[#C8102E] flex-shrink-0 mt-0.5" />
              <span className="text-sm text-zinc-300 leading-relaxed">{item}</span>
            </div>
          ))}
        </div>
      </div>

      <div>
        <p className="chapter-label mb-6">COURSE CONTENT</p>
        <div className="cine-card p-10 md:p-14 border border-white/5 text-center max-w-2xl mx-auto">
          {facultyImage && (
            <div className="w-32 h-32 mx-auto mb-6 rounded-full overflow-hidden border-2 border-[#C8102E]/40">
              <img src={facultyImage} alt={instructor || 'Faculty'} className="w-full h-full object-cover" />
            </div>
          )}
          <h3 className="display-heading text-3xl md:text-4xl text-white mb-4">Coming soon</h3>
          {instructor && (
            <p className="text-sm tracking-[0.15em] uppercase text-[#C8102E] mb-4" data-testid="course-content-instructor">
              Faculty: {instructor}
            </p>
          )}
          <p className="text-base text-zinc-400 leading-relaxed">
            Lessons and modules are being prepared. Full course content will be available here shortly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BeginnerCourseContent;
